// What a form's attachment control accepts — shared by every form that has one.
export const ATTACHMENTS = Object.freeze({
  maxFiles: 5,
  maxBytes: 5 * 1024 * 1024,
  accept: 'application/pdf',
  extension: '.pdf',
});
